import React from "react";
import MatrixOSInfoShell from "./MatrixOSInfoShell";
import { LegalSection, list } from "./legalContentStyles";

export default function AcceptableUse() {
  return (
    <MatrixOSInfoShell eyebrow="Acceptable Use" title="Rules for safe and trustworthy MatrixOS usage." subtitle="These rules protect customer data, platform reliability, operational records, and the integrity of the decisions made from them.">
      <LegalSection title="1. Authorized business use">
        MatrixOS may only be used for lawful, authorized business operations by approved organizations and users with the permissions assigned to them.
      </LegalSection>
      <LegalSection title="2. Prohibited technical activity">
        Users may not attempt unauthorized access, bypass access controls, share credentials improperly, upload malicious code, scrape or clone the platform, interfere with security, reverse engineer protected components, or disrupt service availability.
      </LegalSection>
      <LegalSection title="3. Operational integrity">
        Users must not deliberately falsify or manipulate operational records. This includes attendance, clock-ins, clock-outs, duty completion, schedule decisions, overtime approvals, inventory counts, verification, variance, exposure, delivery records, evidence, alerts, response history, or Matrix League results.
      </LegalSection>
      <LegalSection title="4. Accurate access and ownership">
        Customers must keep staff, manager, site, role, and device permissions accurate. Shared PINs, unmanaged linked devices, false staff assignments, or intentionally incorrect ownership may undermine audit history and may result in restricted access.
      </LegalSection>
      <LegalSection title="5. Messaging and notifications">
        Customers may not use MatrixOS notification channels for spam, harassment, unlawful marketing, or unrelated messaging. Operational WhatsApp or email alerts must be used for legitimate business workflows and valid recipients.
      </LegalSection>
      <LegalSection title="6. Enforcement">
        MatrixOS may investigate suspected misuse and may restrict, suspend, or terminate access where reasonably needed to protect users, customers, the platform, data integrity, or legal compliance.
      </LegalSection>
      <LegalSection title="7. Examples of acceptable use">
        <ul style={list}>
          <li>Clocking staff in and out according to authorized operating procedures.</li>
          <li>Recording duties, exceptions, manager decisions, and response actions accurately.</li>
          <li>Completing and verifying physical stock counts in good faith.</li>
          <li>Using Matrix League only with trusted, approved operational results.</li>
        </ul>
      </LegalSection>
    </MatrixOSInfoShell>
  );
}
